import {useContext, useEffect, useRef, useState} from 'react';
import {EligibleChannelsEndpointResponseSuccess} from '@stripe-internal/conversations-shared-dependencies';
import {ConfigContext} from '../../Providers/ConfigProvider';
import {useApi} from '../../Providers/ApiProvider/ApiProvider';

export const useEligibleChannels = () => {
  const ref = useRef<boolean>(false);
  const [pending, setPending] = useState<boolean>(false);

  const [eligibleChannelsData, setEligibleChannelsData] =
    useState<EligibleChannelsEndpointResponseSuccess | null>(null);

  const {entrypoint, audience} = useContext(ConfigContext);

  const {fetchEligibleChannels} = useApi();

  useEffect(() => {
    if (!eligibleChannelsData && !ref.current) {
      ref.current = true;

      if (!entrypoint) {
        setEligibleChannelsData(null);
        return;
      }

      setPending(true);
      // We pass undefined for the uhConversationId since this is called before a conversation exists.
      // uhConversationId is used to fetch pending RACs for anonymous sessions only. We don't expect to be able
      // to resume a conversation on an anonymous session since we don't have merchant/user to link back to.
      fetchEligibleChannels(entrypoint, audience, undefined)
        .then(setEligibleChannelsData)
        .finally(() => setPending(false));
    }
  }, [audience, fetchEligibleChannels, eligibleChannelsData, entrypoint]);

  return {
    eligibleChannels: eligibleChannelsData?.channels,
    noticeMessage: eligibleChannelsData?.notice_message,
    pending,
  };
};
